// Query params that can carry personal data, and that must never reach analytics. Every other
// param is sent as it is, so attribution params (utm_*, gclid, _hsmi, …) need no list of their own.
// Entries are stored without separators and in lower case: matching ignores both, so one entry
// covers order_id, order-id and orderId.
export const PII_SEARCH_PARAMS: ReadonlySet<string> = new Set([
	'subscription',
	'subscriptionid',
	'bbsubscriptionid',
	'tpssubscriptionid',
	'customercode',
	'msisdn',
	'number',
	'iccid',
	'order',
	'orderid',
	'topupid',
	'topuporderid',
	'mandate',
	'basketid',
	'circuitid',
	'address',
	'simshippingaddress',
	'firstname',
	'lastname',
	'birthdate',
	'iban',
	't',
	'token',
	'authtoken',
	'accesstoken',
	'idtoken',
	'refreshtoken',
	'code',
	'employerinvitationtoken',
	'clanreference',
	'formhash',
	'connections',
	'redirectto',
	'mobilenumber',
	'customerid',
	'wifiname',
	'ssid',
	'fields',
	'generatedresult',
	// HubSpot's id of the contact who received the email. `_hsmi` names only the email, so it stays.
	'hsenc',
]);

/** A param whose name contains one of these is denied too. */
export const PII_SEARCH_PARAM_PARTS: readonly string[] = ['password', 'email', 'phone'];

/** A link that escaped its `&` as `&amp;` arrives with `amp;` in front of every key after the first. */
export function withoutEscapedAmpersand(key: string): string {
	return key.replace(/^(amp;)+/i, '');
}

export function isPiiSearchParam(key: string): boolean {
	const normalized = withoutEscapedAmpersand(key).toLowerCase().replace(/[_-]/g, '');
	if (PII_SEARCH_PARAM_PARTS.some((part) => normalized.includes(part))) return true;
	return PII_SEARCH_PARAMS.has(normalized);
}

export function withoutPiiSearchParams(params: URLSearchParams): URLSearchParams {
	return new URLSearchParams([...params].filter(([key]) => !isPiiSearchParam(key)));
}

/** Also drops a query behind the hash, which can carry a token that no param name gives away. */
export function withoutPiiInUrl(url: URL): URL {
	const sanitized = new URL(url);
	sanitized.search = withoutPiiSearchParams(sanitized.searchParams).toString();

	const hashQueryIndex = sanitized.hash.indexOf('?');
	if (hashQueryIndex > -1) sanitized.hash = sanitized.hash.slice(0, hashQueryIndex);

	return sanitized;
}
